<nav class="navbar navbar-fixed-top bg-gradient-collier text-white">
  <a class="navbar-brand" routerLink="/home" routerLinkActive="active">
    <img src="/assets/logo.png" alt="Logo" >
    Signature Generator
  </a>
  <!-- Menu Items -->

  <!-- Spacer pushes menu+user-status right -->
  <div class="flex-grow-1"></div>

  <ul class="navbar-nav d-inline-flex flex-row ms-3">
    <li class="nav-item mx-3">
      @if(userInfo()?.features!.includes('Admin')) {
        <a class="nav-link text-white" routerLink="/maintenance" routerLinkActive="active">Maintenance</a>
      }
    </li>
  </ul>

  <tcc-user-status-signatures></tcc-user-status-signatures>
</nav>

<div class="contentPanel">

  <router-outlet></router-outlet>
</div>
@if ((state$ | async) != 'ready') {
  <tcc-preloader-signatures>Signature Generator</tcc-preloader-signatures>
}
<tcc-notifications-signatures [defaultDuration]="10000"></tcc-notifications-signatures>

